import axiosClient from '../axiosClient';

const serviceAPI = {
    async getListCategoryAPI(params) {
        const url = `/category_service`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getListServiceAPI(params) {
        const url = `/service`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async getOneServiceAPI(id, params) {
        const url = `/service/${id}`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
    async filterServiceAPI(params) {
        const url = `/category_service`;
        const resp = await axiosClient.get(url, { params });
        return resp;
    },
};

export default serviceAPI;
